// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1838":"8a26378c","5618":"1ba056c9","6762":"1ba056c9"}[chunkId] + ".chunk.css";
};